import styled from 'styled-components';
import { ItemCardStyled } from '../../ui/ItemCard/styled';
import {
  PlaceholderCardPrice,
  PlaceholderCardLocation,
  PlaceholderCardDescription,
  PlaceholderCardDate
} from '../ItemCardPlaceholder/styled';
import { Breakpoints } from '../../../styled/constants';

export const SkeletonItemCard = styled(ItemCardStyled)`
  ${PlaceholderCardPrice} {
    height: 20px;
    margin: 5px 0 0;
  }

  ${PlaceholderCardLocation} {
    height: 18px;
    margin: 5px 0 0;
  }

  ${PlaceholderCardDescription} {
    height: 17px;
    margin: 3px 0 0;
  }

  ${PlaceholderCardDate} {
    height: 15px;
    margin: 5px 0;
  }

  @media (min-width: ${Breakpoints.tablet}px) {
    ${PlaceholderCardPrice} {
      height: 22px;
    }

    ${PlaceholderCardDescription} {
      height: 18px;
    }
  }
`;
